<template>
  <div
    fluid
    text-center
  >
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{ alerta.mensaje }}
    </v-alert>
    <v-spinner v-if="cargando"></v-spinner>
    <template v-else>
      <el-listado
        v-if="listado.mostrar"
        v-bind="listado"
        v-bind:permiso="permiso"
        v-bind:modelo-api="modeloApi"
        v-bind:combos="combos"
        v-on:accion="accionListado"
        v-on:mostrarError="mostrarError"
      ></el-listado>

      <div id="imprimirForm">
        <imprimir
          v-bind:items="imprimir.itemsSeleccionados"
          v-bind:mostrar="imprimir.mostrar"
        >
          <template slot="colgroup">
            <colgroup>
              <col style="width: 85px" />
              <col style="width: 80px" />
              <col style="width: 200px" />
              <col style="width: 160px" />
              <col style="width: 160px" />
            </colgroup>
          </template>
          <template
            slot="cabecera"
            slot-scope="itemImprimir"
          >
            Certificado de Retención N° {{ itemImprimir.numero }}
            <br /><span style="font-size: 10px;">Fecha: {{itemImprimir.fecha | formatoFecha}}</span>
          </template>
          <template
            slot="contenido"
            slot-scope="itemImprimir"
          >
            <tr>
              <th
                class="tg-desc tg-espacio"
                colspan="5"
              >
                <strong>Agente de Retención</strong><br />
                Apellido y Nombre / Denominación: 1996-Asociación Regional de Diálisis y Transplantes Renales<br />
                CUIT: 30646494652
                <br /><br />

                <strong>Sujeto Retenido</strong><br />
                Apellido y Nombre / Denominación: {{ itemImprimir.orden_proyecto_pago.institucion | nombreCentro }}<br />
                CUIT: {{itemImprimir.orden_proyecto_pago.institucion.cuit}}<br />
                Domicilio: {{ domicilioCentro(itemImprimir.orden_proyecto_pago.institucion)}}
                <br /><br />

                <strong>Datos de Retención</strong><br />
                Tipo: {{itemImprimir.tipo}}<br />
                Impuesto: {{itemImprimir.leyenda}}
                <br /><br />
              </th>
            </tr>

            <tr>
              <td
                class="tg-9apd tg-key"
                colspan="5"
              >Órdenes de Pago Afectadas</td>
            </tr>
            <tr>
              <td class="tg-0lax tg-key">N° Orden</td>
              <td class="tg-0lax tg-key">Centro</td>
              <td class="tg-0lax tg-key">Concepto</td>
              <td class="tg-0lax tg-key txt-right">Importe Orden</td>
              <td class="tg-0lax tg-key txt-right">Importe Ret.</td>
            </tr>
            <tr
              v-for="item in itemImprimir.asociadas"
              :key="item.id"
            >
              <template v-if="itemImprimir.tipo === item.tipo">
                <td class="tg-0lax">{{ item.orden_proyecto_pago.id }}</td>
                <td class="tg-0lax">{{ item.orden_proyecto_pago.institucion | nombreCentro }}</td>
                <td class="tg-0lax">{{ item.orden_proyecto_pago.proyecto_pago_version.proyecto_pago.concepto }}</td>
                <td class="tg-0lax txt-right">{{ item.orden_proyecto_pago.importe | currency }}</td>
                <td class="tg-0lax txt-right">{{ item.importe_parcial | currency }}</td>
              </template>
            </tr>
            <tr>
              <td
                class="tg-9apd tg-key txt-right"
                colspan="4"
              >Total</td>
              <td
                class="tg-9apd tg-key txt-right"
                colspan="1"
              >
                {{ sumaImporteAsociadas(itemImprimir) | currency }}
              </td>
            </tr>

            <tr>
              <td
                class="tg-firma txt-right"
                colspan="5"
              >
                <img src="/../static/img/firma_gerente.png">
              </td>
            </tr>
            <tr class="no-print">
              <td
                class="tg-separador"
                colspan="5"
              >
              </td>
            </tr>
          </template>
        </imprimir>

      </div>
    </template>
  </div>
</template>

<script>
import EventBus from '@/helpers/eventBus'
import mixinAbm from '@/mixins/abm'
import ElListado from '../components/RetencionListado'
import Imprimir from '@/components/Imprimir/Imprimir'
import Modelo from '@/api/retencion'
import _ from 'lodash'
import { formatoFecha } from '@/helpers/filtros'
import Vue from 'vue'
import Combo from '@/api/combo'
export default {
  mixins: [mixinAbm],
  filters: { formatoFecha },
  components: {
    ElListado,
    Imprimir
  },
  props: {
    soloLectura: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      montarMixin: false,
      combos: {
        valoresSiNo: [
          { valor: null, nombre: 'Seleccione' },
          { valor: true, nombre: 'Si' },
          { valor: false, nombre: 'No' }
        ]
      },
      cargando: true,
      permiso: 'tesoreria_retenciones',
      modeloApi: Modelo,
      listado: {
        mostrar: false,
        referencia: 'ordenPagosListado'
      },
      imprimir: {
        mostrar: false,
        cargando: false,
        itemsSeleccionados: []
      }
    }
  },
  mounted () {
    this.cargarFiltros()
    this.cargando = false
    this.listado.mostrar = true
  },
  methods: {
    filtrarListado (origen) {
      this.ocultarAlerta()
      EventBus.$emit(this.listado.referencia + ':filtrar')
    },
    cargarFiltros () {
      let vm = this

      let dataCombos = {
        retencionTipos: {
          itemVacio: 'Seleccione'
        },
        instituciones: {
          itemVacio: 'Seleccione',
          soloHijos: true,
          asignados: true
        }
      }
      Combo.listado(dataCombos).then(
        data => {
          vm.combos = _.assign(vm.combos, data)
          vm.cargando = false
          vm.listado.mostrar = true
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },

    imprimirItem (item) {
      let vm = this
      vm.imprimirItems({ ids: [item.id] })
    },
    imprimirSeleccion (items) {
      let vm = this
      let ids = []
      _.forEach(items, item => {
        ids.push(item.id)
      })
      this.$nextTick(() => {
        if (ids.length > 0) {
          vm.imprimirItems({ ids: ids })
        } else {
          vm.mostrarNotificacion('Debe seleccionar por lo menos 1 registro')
        }
      })
    },
    imprimirTodos (filtros) {
      let vm = this
      if (confirm('Desea imprimir todas las retenciones? Este proceso puede tardar varios minutos')) {
        vm.imprimirItems(filtros)
      }
    },
    imprimirItems (filtros) {
      let vm = this
      vm.imprimir.cargando = true
      filtros.para_imprimir = true
      vm.modeloApi.filtrar(filtros).then(
        data => {
          vm.imprimir.cargando = false
          if (data.length > 0) {
            vm.imprimir.itemsSeleccionados = data
            vm.imprimir.mostrar = true

            this.$nextTick(() => {
              let prtHtml = document.getElementById('imprimirForm').innerHTML
              vm.imprimir.mostrar = false
              prtHtml = prtHtml.replace('display: none', '')

              let stylesHtml = ''
              for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML
              }

              // Open the print window
              const WinPrint = window.open(
                '',
                '',
                'left=40px,top=40px,width=750,height=600,toolbar=0,scrollbars=0,status=0'
              )

              WinPrint.document.write(`<!DOCTYPE html>
              <html>
                <head>
                  ${stylesHtml}
                </head>
                <body style="padding: 20px">
                  ${prtHtml}
                </body>
              </html>`)

              WinPrint.document.close()
              WinPrint.focus()
            })
          } else {
            vm.mostrarNotificacion('No se encontraron registros para imprimir.')
          }
        },
        error => {
          vm.imprimir.cargando = false
          vm.mostrarError(error)
        }
      )
    },
    accionListado (accion, item) {
      let vm = this
      switch (accion) {
        case 'imprimirItem':
          vm.imprimirItem(item)
          break
        case 'imprimirSeleccion':
          vm.imprimirSeleccion(item)
          break
        case 'imprimirTodos':
          vm.imprimirTodos()
          break
      }
    },
    mostrarNotificacion (texto) {
      Vue.notify({
        group: 'general',
        type: 'error',
        text: texto
      })
    },
    domicilioCentro (centro) {
      let domicilio = _.find(centro.domicilios, item => {
        return item.principal === true
      })

      if (domicilio) {
        return domicilio.calle.concat(' ').concat(domicilio.numero).concat(' ').concat(domicilio.piso_departamento || '').concat(', ').concat(domicilio.provincia.nombre).concat(' - ').concat(domicilio.localidad.nombre)
      }
      return ''
    },
    sumaImporteAsociadas (itemSeleccionado) {
      let suma = _.sumBy(itemSeleccionado.asociadas, item => {
        return itemSeleccionado.tipo === item.tipo ? Number(item.importe_parcial) : 0
      })

      return suma || 0
    }
  }
}
</script>

<style lang="scss" scoped>
.tg-firma {
  border-left: none !important;
  border-right: none !important;
  padding-top: 80px !important;
  border-bottom: none !important;
}
</style>
